import React, { ReactElement } from 'react';
import './index.less';
const XPModal = (props: any): ReactElement => {
  return (
    <div className={'xp-modal ' + props.cls.modal}>
      <div className={'xp-modal-mask'}></div>
      <div className={'xp-modal-content'}>{props.children}</div>
    </div>
  );
};

export default XPModal;
